import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { deleteMeasuresGroupRulesAsync, getGroupAsync, getGroupMessageAsync, getGroupNotificationsAsync, getGroupServiceStateAlertConfigAsync, getGroupRequiredFieldsConfigAsync, getGroupIntegrationConfigAsync, getGroupResolutionsAsync, getMeasuresGroupRulesAsync, getServiceStateReasonsAsync, postGroupAsync, postGroupServiceNumbersAsync, postMeasuresGroupRulesAsync, putGroupAsync, putGroupServiceNumbersAsync, putMeasuresGroupRulesAsync, getNotMeasuredConfigAsync, getNotMeasuredDeviceTypesAsync, getNotMeasuredServiceRulesAsync, getServiceTypesForGroupAsync, getGroupServiceTypesAdminAsync, getGroupServiceReviewConfigAsync } from './asyncActions';
import { listTransformation } from './operators';

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    setClearGroup: (state) => {
      state.dataGroupDetail.data = null;
      state.rules.data = null;
      state.rules.datalist = null;
      state.notifications.data = [];
      state.serviceStateReasons.data = [];
      state.serviceTypesAdmin.data = [];
      state.serviceReviewConfig.groupId = null;
      state.serviceReviewConfig.own = null;
      state.resolutions.data = [];
      state.serviceStateAlertConfig.data = [];
      state.requiredFieldsConfig.own = null;
      state.requiredFieldsConfig.resolved = { enabled: false, fields: [] };
      state.requiredFieldsConfig.catalog = [];
    },
    setClearRulesDeleted: (state) => {
      state.rulesDeletedState = null;
    },
    setClearRulesCreated: (state) => {
      state.rulesCreatedState = null;
    },
    setClearGroupCreated: (state) => {
      state.groupCreatedState = null;
    },
    setClearGroupServiceNumberCreated: (state) => {
      state.groupServiceNumberCreatedState = null;
    },
    setRulesSelected: (state, action: PayloadAction<any>) => {
      state.ruleSelected = action.payload;
    },
    setOpenRulesSelected: (state, action: PayloadAction<boolean>) => {
      state.openRuleSelected = action.payload;
    },
    setOpenModalGroupNotificationShow: (state, { payload }: PayloadAction<boolean>) => {
      state.openModalNotificationShow = payload;
    },
    setOpenModalGroupNotificationSend: (state, { payload }: PayloadAction<boolean>) => {
      state.openModalNotificationSend = payload;
    },
    setOpenModalGroupNotificationEdit: (state, { payload }: PayloadAction<boolean>) => {
      state.openModalNotificationEdit = payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroupAsync.pending, (state) => {
        state.dataGroupDetail.status = 'loading';
      })
      .addCase(getGroupAsync.fulfilled, (state, action) => {
        state.dataGroupDetail.status = 'idle';
        state.dataGroupDetail.data = action.payload?.item;
      })
      .addCase(getGroupAsync.rejected, (state) => {
        state.dataGroupDetail.status = 'failed';
      })
      .addCase(postGroupAsync.fulfilled, (state, action) => {
        state.groupCreatedState = action.payload?.data?.success;
      })
      .addCase(putGroupAsync.fulfilled, (state, action) => {
        state.groupCreatedState = action.payload?.data?.success;
      })
      .addCase(postGroupServiceNumbersAsync.fulfilled, (state, action) => {
        state.groupServiceNumberCreatedState = action.payload?.data?.success;
      })
      .addCase(putGroupServiceNumbersAsync.fulfilled, (state, action) => {
        state.groupServiceNumberCreatedState = action.payload?.data?.success;
      })
      .addCase(getGroupMessageAsync.pending, (state) => {
        state.dataGroupDetail.status = 'loading';
      })
      .addCase(getGroupMessageAsync.fulfilled, (state, action) => {
        state.groupMessage.status = 'idle';
        state.groupMessage.data = action.payload?.item?.items;
      })
      .addCase(getGroupMessageAsync.rejected, (state) => {
        state.dataGroupDetail.status = 'failed';
      })
      .addCase(getMeasuresGroupRulesAsync.fulfilled, (state, action) => {
        state.rules.data = action.payload?.data?.items;
        state.rules.status = 'idle';
        state.rules.datalist = listTransformation(action.payload?.data?.items, action.meta?.arg?.optionMeasureUnits, action.meta?.arg?.optionGenericMeasureTypes);
      })
      .addCase(postMeasuresGroupRulesAsync.fulfilled, (state, action) => {
        state.rulesCreatedState = action.payload?.data?.success;
      })
      .addCase(putMeasuresGroupRulesAsync.fulfilled, (state, action) => {
        state.rulesCreatedState = action.payload?.data?.success;
      })
      .addCase(deleteMeasuresGroupRulesAsync.fulfilled, (state, action) => {
        state.rulesDeletedState = action.payload?.data?.success;
      })
      .addCase(getGroupNotificationsAsync.pending, (state) => {
        state.notifications.status = 'loading';
      })
      .addCase(getGroupNotificationsAsync.fulfilled, (state, action) => {
        state.notifications.status = 'idle';
        state.notifications.data = action.payload?.data?.item?.items;
        state.notifications.pagination.total = action.payload?.data?.item?.total;
      })
      .addCase(getGroupNotificationsAsync.rejected, (state) => {
        state.notifications.status = 'failed';
      })
      .addCase(getServiceStateReasonsAsync.pending, (state) => {
        state.serviceStateReasons.status = 'loading';
      })
      .addCase(getServiceStateReasonsAsync.fulfilled, (state, action) => {
        state.serviceStateReasons.status = 'idle';
        state.serviceStateReasons.data = action.payload?.item?.items ?? [];
      })
      .addCase(getServiceStateReasonsAsync.rejected, (state) => {
        state.serviceStateReasons.status = 'failed';
      })
      .addCase(getGroupResolutionsAsync.pending, (state) => {
        state.resolutions.status = 'loading';
      })
      .addCase(getGroupResolutionsAsync.fulfilled, (state, action) => {
        state.resolutions.status = 'idle';
        state.resolutions.data = action.payload?.item?.items ?? [];
      })
      .addCase(getGroupResolutionsAsync.rejected, (state) => {
        state.resolutions.status = 'failed';
      })
      .addCase(getGroupServiceStateAlertConfigAsync.pending, (state) => {
        state.serviceStateAlertConfig.status = 'loading';
      })
      .addCase(getGroupServiceStateAlertConfigAsync.fulfilled, (state, action) => {
        state.serviceStateAlertConfig.status = 'idle';
        state.serviceStateAlertConfig.data = action.payload?.items ?? [];
      })
      .addCase(getGroupServiceStateAlertConfigAsync.rejected, (state) => {
        state.serviceStateAlertConfig.status = 'failed';
      })
      .addCase(getNotMeasuredConfigAsync.pending, (state) => {
        state.notMeasuredConfig.status = 'loading';
      })
      .addCase(getNotMeasuredConfigAsync.fulfilled, (state, action) => {
        state.notMeasuredConfig.status = 'idle';
        state.notMeasuredConfig.data = action.payload?.items?.[0] ?? null;
      })
      .addCase(getNotMeasuredConfigAsync.rejected, (state) => {
        state.notMeasuredConfig.status = 'failed';
      })
      .addCase(getNotMeasuredDeviceTypesAsync.pending, (state) => {
        state.notMeasuredDeviceTypes.status = 'loading';
      })
      .addCase(getNotMeasuredDeviceTypesAsync.fulfilled, (state, action) => {
        state.notMeasuredDeviceTypes.status = 'idle';
        state.notMeasuredDeviceTypes.data = action.payload?.items ?? [];
      })
      .addCase(getNotMeasuredDeviceTypesAsync.rejected, (state) => {
        state.notMeasuredDeviceTypes.status = 'failed';
      })
      .addCase(getNotMeasuredServiceRulesAsync.pending, (state) => {
        state.notMeasuredServiceRules.status = 'loading';
      })
      .addCase(getNotMeasuredServiceRulesAsync.fulfilled, (state, action) => {
        state.notMeasuredServiceRules.status = 'idle';
        state.notMeasuredServiceRules.data = action.payload?.items ?? [];
      })
      .addCase(getNotMeasuredServiceRulesAsync.rejected, (state) => {
        state.notMeasuredServiceRules.status = 'failed';
      })
      .addCase(getServiceTypesForGroupAsync.pending, (state) => {
        state.groupServiceTypes.status = 'loading';
      })
      .addCase(getServiceTypesForGroupAsync.fulfilled, (state, action) => {
        state.groupServiceTypes.status = 'idle';
        state.groupServiceTypes.data = action.payload?.items ?? [];
      })
      .addCase(getServiceTypesForGroupAsync.rejected, (state) => {
        state.groupServiceTypes.status = 'failed';
      })
      .addCase(getGroupServiceTypesAdminAsync.pending, (state) => {
        state.serviceTypesAdmin.status = 'loading';
      })
      .addCase(getGroupServiceTypesAdminAsync.fulfilled, (state, action) => {
        state.serviceTypesAdmin.status = 'idle';
        state.serviceTypesAdmin.data = action.payload?.items ?? [];
      })
      .addCase(getGroupServiceTypesAdminAsync.rejected, (state) => {
        state.serviceTypesAdmin.status = 'failed';
      })
      .addCase(getGroupServiceReviewConfigAsync.pending, (state) => {
        state.serviceReviewConfig.status = 'loading';
      })
      .addCase(getGroupServiceReviewConfigAsync.fulfilled, (state, action) => {
        state.serviceReviewConfig.status = 'idle';
        state.serviceReviewConfig.groupId = action.payload?.groupId ?? null;
        state.serviceReviewConfig.own = action.payload?.own ?? null;
        state.serviceReviewConfig.resolved = action.payload?.resolved ?? state.serviceReviewConfig.resolved;
      })
      .addCase(getGroupServiceReviewConfigAsync.rejected, (state) => {
        state.serviceReviewConfig.status = 'failed';
      })
      .addCase(getGroupRequiredFieldsConfigAsync.pending, (state) => {
        state.requiredFieldsConfig.status = 'loading';
      })
      .addCase(getGroupRequiredFieldsConfigAsync.fulfilled, (state, action) => {
        state.requiredFieldsConfig.status = 'idle';
        state.requiredFieldsConfig.own = action.payload?.own ?? null;
        state.requiredFieldsConfig.resolved = action.payload?.resolved ?? { enabled: false, fields: [] };
        state.requiredFieldsConfig.catalog = action.payload?.catalog ?? [];
      })
      .addCase(getGroupRequiredFieldsConfigAsync.rejected, (state) => {
        state.requiredFieldsConfig.status = 'failed';
      })
      .addCase(getGroupIntegrationConfigAsync.pending, (state) => {
        state.integrationConfig.status = 'loading';
      })
      .addCase(getGroupIntegrationConfigAsync.fulfilled, (state, action) => {
        state.integrationConfig.status = 'idle';
        state.integrationConfig.groupId = action.meta.arg; // grupo al que pertenece lo cargado
        state.integrationConfig.fhir = action.payload?.fhir ?? null;
        state.integrationConfig.sync = action.payload?.sync ?? { items: [], own: false, sourceGroupId: null };
      })
      .addCase(getGroupIntegrationConfigAsync.rejected, (state) => {
        state.integrationConfig.status = 'failed';
      });
  }
});

export const {
  setClearGroup,
  setClearRulesDeleted,
  setClearRulesCreated,
  setClearGroupCreated,
  setRulesSelected,
  setOpenRulesSelected,
  setClearGroupServiceNumberCreated,
  setOpenModalGroupNotificationShow,
  setOpenModalGroupNotificationSend,
  setOpenModalGroupNotificationEdit,
} = groupSlice.actions;

export default groupSlice.reducer;
